import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as config from '../shared/config/app.config';
import { BaseService } from '../shared/services/base.service';
import { ExcelDownloadService } from '../shared/services/excel-download.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentHistoryService {

  public userData = new BehaviorSubject<any>(null);
  userData$ = this.userData.asObservable();
  public detailsSummary = new BehaviorSubject<any>(null);
  detailsSummary$ = this.detailsSummary.asObservable();
  public legacyPayment = new BehaviorSubject<any>(null);
  legacyPayment$ = this.legacyPayment.asObservable();
  public transactionalData = new BehaviorSubject<any>(null);
  transactionalData$ = this.transactionalData.asObservable();

  constructor(
    public baseService: BaseService,
    public excelService: ExcelDownloadService
  ) { }

  public getPaymentHistory(params, filters?) {
    this.baseService
      .get(`/my-account/${params.userId}/paymenthistory`, filters)
      .subscribe((res) => {
        this.userData.next(res);
      });
  }

  public getLegacyPaymentHistory(params, filters) {
    this.baseService
      .get(`/my-account/${params.userId}/legacyPaymenthistory`, filters)
      .subscribe((res) => {
        this.legacyPayment.next(res);
      });
  }

  public getPieChartDetails(params, filters?) {
    return this.baseService
      .get(`/my-account/${params.userId}/paymentsummary`, filters)
  }

  public downloadXls(data, name) {
    this.excelService.exportAsExcelFile(data, name, true);
  }

  public downloadPdf(params): void {
    this.baseService
      .getPdf(config.DOWNLOAD_INVOICE_CREDIT_PDF, { invoiceNumber: params })
      .subscribe((res) => {
        const file = new Blob([res], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      });
  }

  getInvoicepdf(params) {
    this.baseService
      .getPdf(config.DOWNLOAD_INVOICE_PDF, { invoiceNumber: params })
      .subscribe((res) => {
        const file = new Blob([res], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      });
  }

  getTransactionalDetails(params, filters) {
    return this.baseService
      .get(`/my-account/${params.userId}/legacyTransactional-data`, filters)
  }

}
